const Footer=()=>
    {
     
        return(

            <footer id="footer">
  <div class="footer">
    <div class="container_main">
      <div class="logo_footer">
        <a href="">
          <img src="https://giadinh.edu.vn/upload/photo/logofooter-8814.png" alt="Logo"/>
        </a>
      </div>
      <div class="content_footer">
        <h2>TRƯỜNG ĐẠI HỌC GIA ĐỊNH</h2>
        <p>Cơ sở Tân Sơn Nhất: 371 Nguyễn Kiệm, P.3, Q.Gò Vấp, TP.HCM</p>

<p>Hotline: 0961 12 10 18 - 0962 12 10 18 - 0862 12 10 18</p>

<p>Điện thoại: (028)7301.3456</p>

<p>Email: tuyensinh@giadinh.edu.vn</p>
      </div> 
      <div class="banner_footer">
       
      </div>
    </div>
  </div>
  <div class="copyright">
    <div class="container_main">
      <p>© 2024 Demo bởi thầy Gia.<a> | Sitemap</a></p>
    </div>
  </div>
</footer>

        );

    }
export default Footer;